// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__13EkF","head":"Table_head__URLAs","col":"Table_col__2-Hzz"};